/* eslint-disable no-unused-vars */
export default {
  prescriptionType: 'SIMPLE',
  prescriptionFlows: ['MANUAL', 'ACCOUNT', 'UPLOAD', 'CMD'],
  fileExtensions: ['png', 'gif', 'jpeg', 'tiff', 'bmp', 'word', 'pdf'],
  maxFileSize: 10,

  loadPrescription: function () {
    var _prescriptionObject = null

    return new Promise(function (resolve, reject) {
      var value = null
      var name = '_prescriptionObject='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          value = c.substring(name.length, c.length)
        }
      }

      if (value) {
        try {
          _prescriptionObject = JSON.parse(value)
          // validation is run by the configuration agains the return object
          resolve(_prescriptionObject)
        } catch (e) {
          console.log(e)
          reject()
        }
      } else {
        resolve(null)
      }
    })
  },

  savePrescription: function (_prescriptionObject) {
    document.cookie = '_prescriptionObject=' + JSON.stringify(_prescriptionObject)

    return true // or false if failure
  },

  // if no lenses are available against the prescription filtering, this function is called to retrieve the frames filtered PLP URL to link in the dedicated CTA "see available frames"
  // the PLP must be of the same category of the frame
  // if no URL is returned, then the user won't see the CTA

  checkAvailableFrames: function (_frame, _prescriptionObject) {
    //var filteredFramesURL = "/lc-us/sunglasses";
    var filteredFramesURL = null
    return filteredFramesURL
  },

  // it removes the cookie information
  clearPrescription: function () {
    document.cookie = '_prescriptionObject=; Max-Age=-99999999;'
  },
}
